import styled, { keyframes } from 'vue3-styled-components';

export const scanPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
  50% {
    box-shadow: 0 0 15px 5px rgba(76, 175, 80, 0.5);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
`;

// 무지개색 애니메이션 정의
export const rainbowBorder = keyframes`
  0% { border-color: #ff0000; box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); }
  14% { border-color: #ff7f00; box-shadow: 0 0 10px rgba(255, 127, 0, 0.7); }
  28% { border-color: #ffff00; box-shadow: 0 0 10px rgba(255, 255, 0, 0.7); }
  42% { border-color: #00ff00; box-shadow: 0 0 10px rgba(0, 255, 0, 0.7); }
  56% { border-color: #0000ff; box-shadow: 0 0 10px rgba(0, 0, 255, 0.7); }
  70% { border-color: #4b0082; box-shadow: 0 0 10px rgba(75, 0, 130, 0.7); }
  84% { border-color: #9400d3; box-shadow: 0 0 10px rgba(148, 0, 211, 0.7); }
  100% { border-color: #ff0000; box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); }
`;

// 배경색 무지개 효과
export const rainbowBackground = keyframes`
  0% { background-color: rgba(255, 0, 0, 0.05); }
  14% { background-color: rgba(255, 127, 0, 0.05); }
  28% { background-color: rgba(255, 255, 0, 0.05); }
  42% { background-color: rgba(0, 255, 0, 0.05); }
  56% { background-color: rgba(0, 0, 255, 0.05); }
  70% { background-color: rgba(75, 0, 130, 0.05); }
  84% { background-color: rgba(148, 0, 211, 0.05); }
  100% { background-color: rgba(255, 0, 0, 0.05); }
`;

export const ProductListDiv = styled.div`
    max-width: 100%;
    margin: 0 auto;
    padding: 0 20px 20px 20px;
`;

export const ProductListTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-weight: bold;
    color: #cc5803
    margin: 10px;
    text-align: center;
    width: 98%;
    .MaterialIcons{
        width: 30px;
        height: 30px;
    }
    svg{
        width: 100%;
        height: 100%;
    }
`;

// 메인 카테고리 탭 컨테이너
export const MainCategoryTabs = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px auto 15px;
  margin-bottom: 10px;
  width: 50%;
  border-radius: 8px;
  background-color: #f5f5f5;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

// 메인 카테고리 탭 버튼
export const MainCategoryTab = styled.button`
  flex: 1;
  padding: 10px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 15px;
  transition: all 0.3s ease;
  position: relative;
  color: #555;
  
  &.active {
    color: white;
    background-color: #0f4c5c;
    font-weight: bold;
  }
  
  &:hover:not(.active) {
    background-color: rgba(15, 76, 92, 0.1);
  }
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background-color: #0f4c5c;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }
  
  &.active:after {
    width: 100%;
  }
`;

// ! 카테고리 영역
export const ProductListCategoryArea = styled.div`
  padding: 15px;
  margin-bottom: 20px;
  background-color: #fff9f1;
  border-radius: 5px;
  box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.1), 0 2px 9px 0 rgba(0, 0, 0, 0.1);
`;

export const MainCategorySection = styled.div`
  flex: 0.9;
  background-color: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  max-height: 600px;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  }
`;

export const MainCategoryHeader = styled.div`
  padding: 10px;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a7a8c 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const MainCategoryTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
`;

export const SubCategoryContent = styled.div`
  padding: 20px;
  transition: all 0.3s ease;
  overflow-y: auto;
  flex-grow: 1;
  background-color: #f8f9fa;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #0f4c5c;
    border-radius: 4px;
  }
`;

export const CategorySection = styled.div`
  margin-bottom: 24px;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const CategoryLabel = styled.span`
  display: inline-block;
  color: #0f4c5c;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 4px solid #0f4c5c;
`;

export const CategoryButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const CategoryButton = styled.button`
  background-color: #ffffff;
  color: #0f4c5c;
  border: 2px solid #0f4c5c;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 100px;
  text-align: center;
  
  &:hover {
    background-color: #0f4c5c;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(15, 76, 92, 0.15);
  }
  
  &.active {
    background-color: #0f4c5c;
    color: #ffffff;
    border-color: #0f4c5c;
    box-shadow: 0 4px 12px rgba(15, 76, 92, 0.2);
  }
`;

export const LocationCategoryButton = styled.button`
  background-color: #ffffff;
  color: #0f4c5c;
  border: 2px solid #0f4c5c;
  padding: 6px 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  text-align: center;
  
  &:hover {
    background-color: #0f4c5c;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(15, 76, 92, 0.15);
  }
  
  &.active {
    background-color: #0f4c5c;
    color: #ffffff;
    border-color: #0f4c5c;
    box-shadow: 0 4px 12px rgba(15, 76, 92, 0.2);
  }
`;

// ! 안전재고 영역
export const ProductListFlexContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const SafetyStockArea = styled.div`
  flex: 0.8;
  min-width: 300px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  display: flex;
  flex-direction: column;
  max-height: 500px;
`;

export const SafetyStockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 0;
`;

export const SafetyStockLeftGroup = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const SafetyStockCenterGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const SafetyStockInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 155px;
`;

export const SafetyStockInput = styled.input`
  width: 120px;
  padding: 10px 12px;
  font-size: 14px;
  border: 2px solid rgba(15, 76, 92, 0.2);
  border-radius: 8px;
  color: #333;
  background-color: #fff;
  
  &:hover {
    border-color: rgba(15, 76, 92, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  right: 25px;
  top: 55%;
  transform: translateY(-50%);
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #0066cc;
  }
`;

export const SafetyStockSelect = styled.select`
  width: 140px;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  background-color: #fff;
  border: 2px solid rgba(15, 76, 92, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: rgba(15, 76, 92, 0.4);
  }
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
  }
  
  & option {
    padding: 8px;
    font-size: 14px;
  }
`;

export const SafetyStockTitle = styled.h3`
  font-size: 23px;
  font-weight: bold;
  color: #0f4c5c;
  margin: 0;
  white-space: nowrap;
`;

export const SafetyStockCount = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  height: 32px;
  padding: 0 12px;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a7a8c 100%);
  color: white;
  border-radius: 16px;
  margin-left: 12px;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(15, 76, 92, 0.15);
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(15, 76, 92, 0.2);
  }
`;


export const SafetyStockTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  
  & thead {
    top: 0;
    background-color: #fff;
    z-index: 10;
    width: 100%;
  }
  
  & tbody {
    width: 100%;
  }
  
  & tr {
    width: 100%;
  }
  
  /* 로딩 중 테이블 행 스타일 */
  & tr.loading-row td {
    color: transparent;
    position: relative;
  }
`;

export const SafetyStockTh = styled.th`
  background: #0f4c5c;
  color: #ffffff;
  text-align: center;
  padding: 8px 8px;
  font-weight: 500;
  font-size: 14px;
  position: sticky;
  top: 0;
  border: none;
  
  &:first-child {
    border-top-left-radius: 8px;
  }
  
  &:last-child {
    border-top-right-radius: 8px;
  }
`;

export const SafetyStockTd = styled.td`
  padding: 8px 8px;
  text-align: center;
  border-bottom: 1px solid rgba(15, 76, 92, 0.1);
  font-size: 15px;
  color: #333;
  transition: all 0.2s ease;
  
  // 빈 메시지일 때 추가 스타일
  &.empty-message {
    text-align: center;
    padding: 40px 0;
    font-style: italic;
    background-color: #f9fafb;
    border-radius: 8px;
  }
`;

export const SafetyStockTr = styled.tr`
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(15, 76, 92, 0.05);
    transform: translateY(-1px);
  }
`;

export const SafetyStockEditContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const SafetyStockEditButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background-color: #e4f0f5;
  color: #0f4c5c;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    color: #ffffff;
    background-color: #0f4c5c;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(15, 76, 92, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &[title] {
    position: relative;
  }
  
  &[title]:hover::after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    border-radius: 4px;
    background-color: #cc5803;
    color: white;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    margin-bottom: 12px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
`;

export const OrderButton = styled.button`
  background: linear-gradient(135deg, #0f4c5c 0%, #1a7a8c 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 7px 14px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(15, 76, 92, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const SafetyStockEmpty = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #666;
  font-size: 14px;
`;

export const SafetyStockLoading = styled.div`
  padding: 10px;
  text-align: center;
  font-weight: bold;
  margin-top: 70px;
`;

export const StyledSafetyStockTd = styled.div`
  padding: 10px;
  text-align: center;
  font-weight: bold;
  margin-top: 70px;
`;

// * 페이지네이션
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 10px;
  margin-top: auto;
`;

export const PageButton = styled.button`
  min-width: 36px;
  height: 36px;
  padding: 0 8px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  
  &:hover {
    background-color: #e4f0f5;
  }
  
  &.active {
    background-color: #0f4c5c;
    color: white;
    border-color: #0f4c5c;
    font-weight: bold;
    z-index: 1;
    
    &.loading-state {
      background-color: #0f4c5c;
      color: white;
    }
  }
  
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    width: 0;
    background-color: #ff8800;
    transition: width 0.3s ease;
  }
  
  /* 로딩 중에만 보여줄 로딩 인디케이터 */
  &.loading-indicator::after {
    width: 100%;
  }
`;


// ! 검색 영역
export const ProductListSearchArea = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 20px;
    
    input{
        width: 100%;
        padding: 10px;
        font-size: 16px;
    }
`;

// 바코드 스캔 버튼 활성 상태 스타일 추가
export const ProductlistHeaderBtn = styled.button`
  background-color: #0f4c5c;
  color: white;
  border: none;
  padding: 10px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    background-color: #1a7a8c;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(15, 76, 92, 0.2);
  }
  
  &.active {
    background-color: #ff6b00;
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 107, 0, 0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(255, 107, 0, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 107, 0, 0);
    }
  }
`;

export const BarcodeDisplayArea = styled.div`
  background-color: #0f4c5c;
  color: white;
  border: none;
  padding: 10px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background-color: #1a7a8c;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(15, 76, 92, 0.2);
  }

  &.active {
    border: 2px solid #0f4c5c;
    animation: ${rainbowBorder} 4s linear infinite;
    background-color: white;
    position: relative;
    overflow: hidden;
    color: #0f4c5c;
    font-weight: bold;
      
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.85);
      z-index: -1;
      animation: ${rainbowBackground} 4s linear infinite;
    }
  }
`;

export const ProductListHeaderH2 = styled.h2`
    font-size: 20px;
    font-weight: bold;
    margin-right: 10px;
`

export const ProductListHeaderBtnArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
`

export const HeaderLeftGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

export const HeaderCenterGroup = styled.div`
    display: flex;
    align-items: center;
`;

export const HeaderRightGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`

export const ProductListNewInput = styled.input`
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #000000;
    border-radius: 5px;
    height: 30px;
`

export const ProductListSearchInput = styled.input`
    padding: 8px;
    margin: 10px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 20px;
    width: 250px;
    font-size: 16px;
    &::placeholder {
        color: #999;
    }
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 5px rgba(15, 76, 92, 0.5);
    }
`;

export const ProductListNewSelect = styled.select`
    width: 100%;
    margin: 10px 0;
    border: 1px solid #000000;
    border-radius: 5px;
    height: 40px;
`

export const ProductlistDetailModalArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const ProductlistDetailBcodeArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const ProductlistDetailBcodeAreaTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const ProductlistDetailBcodeAreaBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;
`
export const ProductlistDetailBcodeTableDiv = styled.div`
  height:300px;
`

export const ProductListDetailBcodeReleaseArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 30%;
    height: 100%;
`

export const ProductListTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(251, 139, 36, 0.1);
  margin: 20px 0;
  border: 1px solid #fed7aa;
`;

export const ProductListTh = styled.th`
  border: none;
  padding: 14px 12px;
  text-align: center;
  background: linear-gradient(135deg, #fb8b24 0%, #ea580c 100%);
  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  
  &:first-child {
    border-top-left-radius: 12px;
  }
  
  &:last-child {
    border-top-right-radius: 12px;
  }
  
  /* 반응형 텍스트 크기 */
  @media (max-width: 768px) {
    padding: 12px 8px;
    font-size: 11px;
  }
`;

export const ProductListTd = styled.td`
  border: none;
  border-bottom: 1px solid #fed7aa;
  padding: 6px 10px;
  text-align: center;
  background-color: #ffffff;
  color: #333333;
  font-size: 14px;
  line-height: 1.4;
  transition: all 0.2s ease;
  
  /* 이미지 셀 특별 스타일링 */
  img {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(251, 139, 36, 0.2);
    transition: transform 0.2s ease;
    border: 2px solid #fed7aa;
    
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 16px rgba(251, 139, 36, 0.3);
      border-color: #fb8b24;
    }
  }
  
  @media (max-width: 768px) {
    padding: 12px 8px;
    font-size: 12px;
  }
`;

export const ProductListTr = styled.tr`
  &:hover {
    background: linear-gradient(90deg, #fff7ed 0%, #ffedd5 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(251, 139, 36, 0.1);
    cursor: pointer;
    
    td {
      border-bottom-color: #fb8b24;
    }
  }
  
  &:last-child td {
    border-bottom: none;
  }
  
  /* 짝수 행 배경색 */
  &:nth-child(even) {
    background-color: #fffbf5;
  }
  
  /* 활성 상태 */
  &:active {
    transform: translateY(0);
    background: #ffedd5;
  }
`;

export const ProductListTableArea = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  margin: 20px 0;
  box-shadow: 0 8px 32px rgba(251, 139, 36, 0.08);
  border: 1px solid #fed7aa;
  
  /* 스크롤바 스타일링 */
  overflow-x: auto;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #fff7ed;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #fb8b24;
    border-radius: 4px;
    
    &:hover {
      background: #ea580c;
    }
  }
  
  /* 반응형 디자인 */
  @media (max-width: 768px) {
    padding: 16px;
    margin: 16px 0;
    border-radius: 12px;
  }
`;

export const CategoryCell = styled(ProductListTd)`
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  font-weight: 600;
  color: #9a3412;
  border-right: 3px solid #fb8b24;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #fb8b24 0%, #ea580c 100%);
  }
`;

// 가격 셀 전용 컴포넌트 생성
export const PriceCell = styled(ProductListTd)`
  font-weight: 600;
  color: #ea580c;
  font-family: 'Roboto Mono', monospace;
  
  &::after {
    content: '원';
    margin-left: 2px;
    font-size: 12px;
    opacity: 0.8;
  }
`;

// 비고 셀 전용 컴포넌트 생성
export const NoteCell = styled(ProductListTd)`
  color: #6b7280;
  font-style: italic;
  
  /* 비고가 없을 때 스타일 */
  &.empty {
    color: #d1d5db;
  }
  
  /* 특정 텍스트에 대한 스타일 */
  &.no-barcode {
    color: #dc2626;
    font-weight: 500;
    background: #fef2f2;
    border-radius: 4px;
    padding: 4px 8px;
    border: 1px solid #fecaca;
  }
`;

export const StockBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  background: #f0fdf4;
  color: #059669;
  border: 1px solid #bbf7d0;
`;

// 코드 스타일 (바코드, 제품코드, 대상, 색상, 사이즈)
export const StandardBadge = styled.span`
  background: #fff7ed;
  color: #9a3412;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  border: 1px solid #fed7aa;
  font-weight: 500;
  font-style: normal;
`;

// * 재고 페이지네이션 영역
export const ProductListPageArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
  padding: 20px 0;
`;

export const ProductListBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 8px 12px;
  border: 2px solid #fed7aa;
  background: #ffffff;
  color: #fb8b24;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #fb8b24;
    color: #ffffff;
    border-color: #fb8b24;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(251, 139, 36, 0.3);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(251, 139, 36, 0.2);
  }
  
  &:disabled {
    background: #f9fafb;
    color: #d1d5db;
    border-color: #e5e7eb;
    cursor: not-allowed;
    opacity: 0.5;
  }
  
  &.current-page {
    background: linear-gradient(135deg, #fb8b24 0%, #ea580c 100%);
    color: #ffffff;
    border-color: #fb8b24;
    box-shadow: 0 4px 12px rgba(251, 139, 36, 0.4);
    transform: translateY(-1px);
  }
`;

export const BtnContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const ProductListImg = styled.img`
    width: 100px;
    height: auto;
    object-fit: cover;
    transition: transform 0.3s ease;
    &:hover{
        transform: scale(1.5);
    }
`

export const QuantityBtn = styled.div`
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align : center;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    margin: 10px;
    &:hover{
        cursor: pointer;
    }
`

export const QuantityBtnArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`

export const QuantityInput = styled.input`
    width: 30px;
    height: 30px;
    text-align : center;
    border-radius: 5px;
    font-weight: bold;
    margin: 10px;
    border: 1px solid #000000;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`

export const ProductSearchBtn = styled.button`
    box-shadow: 0 8px 9px -4px rgba(0,0,0,0.3), 0 4px 18px 0 rgba(0,0,0,0.2);
    border-radius: 5px;
    border: none;
    background: #fff;
    color: #000;
    width: 50px;
    margin-left: 10px;
    height: 37px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

// !엑셀 재고등록 모달 스타일드
export const ExcelUploadDiv = styled.div`
  padding: 20px;
  text-align: center;
`;

export const ExcelUploadTitle = styled.h2`
  margin-bottom: 10px;
  color: #333;
  font-size: 30px;
`;

export const ExcelUploadSubTitle = styled.p`
  margin-bottom: 20px;
  color: #cc5803;
  font-size: 16px;
  font-weight: 600;
`;

export const ExcelUploadBtnArea = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  padding-top: 20px;
`;

export const ExcelUploadBtn = styled.button`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  background-color: rgb(48, 110, 72);
  font-size: 20px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;

    &:hover {
      background-color: #45a049;
      cursor: pointer;
      transform: translateY(-3px);
      box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

// 로딩 스피너 컴포넌트
export const LoadingOverlay = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 60px 20px;
    background: #ffffff;
    border-radius: 8px;
    position: relative;
`;

export const LoadingSpinner = styled.div`
    width: 48px;
    height: 48px;
    border: 4px solid #e5e7eb;
    border-top-color: #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 20px;
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export const LoadingText = styled.div`
    font-size: 15px;
    font-weight: 400;
    color: #374151;
    letter-spacing: 0;
    line-height: 1.5;
`;